module.exports = __webpack_public_path__ + "img/1982_no.b82534f8.svg";